import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { FavoriteListing } from './types/FavoriteListing';
import { APIV2_URL } from './constants';

export interface FavoriteListingsResource {
  favorites: FavoriteListing[];
  count: number;
}

export interface Options {
  expand?: string;
  withPhotos?: string;
}

export type GetFavoriteListingsCall = (
  userId: number,
  options?: Options,
) => Promise<{
  data: FavoriteListingsResource;
}>;

export default (makeCall: MakeCall) => (userId: number, options?: Options) =>
  makeCall<FavoriteListingsResource>('GET', `${APIV2_URL}/listings/favorites`, {
    query: { userId, ...options },
  });
